<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h4>{{ 'pages.transport.detail-page.milestones.headline' | translate }}</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-12" [ngClass]="{ 'margin-helper': timelineLayout() === 'vertical' }">
        <p-timeline [value]="events()" [layout]="timelineLayout()" [align]="timelineAlign()" styleClass="milestones__timeline">
          <ng-template #marker let-event>
            <span class="milestone__marker p-shadow-2" [ngClass]="event.severity">
              <i [ngClass]="event.icon"></i>
            </span>
          </ng-template>

          <ng-template #content let-event>
            <span class="milestone__headline bold text-uppercase">{{ event.headline }}</span>
            <p class="milestone__details">{{ event.description }}</p>
          </ng-template>
        </p-timeline>
      </div>
    </div>
  </div>
</div>
